import { toValue, watchEffect, type MaybeRefOrGetter } from "vue";

export const DEFAULT_INTERVAL_TIME = 1000 as const;

export function useInterval(
  fn: MaybeRefOrGetter<() => void>,
  time: MaybeRefOrGetter<number>,
) {
  watchEffect((onCleanup) => {
    const fnValue = "value" in fn ? fn.value : fn;
    const timeValue = toValue(time);

    if (timeValue <= 0) {
      return;
    }

    const effectiveTimeValue = Math.max(DEFAULT_INTERVAL_TIME, timeValue);

    const interval = setInterval(fnValue, effectiveTimeValue);

    onCleanup(() => {
      clearInterval(interval);
    });
  });
}
